module.exports = __webpack_public_path__ + "mainassets/img/question-circle.5b71b688.svg";